import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  style: {"display":"contents"},
  ref: "root"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "ProductCategory-content"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { "data-slot": "recommended-list" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterHolder = _resolveComponent("FilterHolder")!
  const _component_FilterSelection = _resolveComponent("FilterSelection")!
  const _component_CategorySort = _resolveComponent("CategorySort")!
  const _component_ProductList = _resolveComponent("ProductList")!
  const _component_Pager = _resolveComponent("Pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FilterHolder),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Načítáme produkty..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_FilterSelection),
          _createVNode(_component_CategorySort),
          _createVNode(_component_ProductList),
          _createVNode(_component_Pager)
        ]))
  ], 512))
}